<div class="pension-modal">
  <div class="header">
    <h2>{{ data?.title }}</h2>
    <div class="icon-container">
      <ion-icon class="i-close"
       (click)="data?.closeButton()"
       (keypress)="true"></ion-icon>
    </div>
  </div>
  <div class="div-label">
    <ng-container *ngIf="index === 1">
      <p class="text-document">
        <span class="fw-600">Tu propio</span> certificado de nacimiento emitido
        por el registro civil.
      </p>
    </ng-container>

    <ng-container *ngIf="index === 2">
      <p class="text-document">
        El certificado de nacimiento emitido por el registro civil
        <span class="fw-600">de tu cónyuge</span> (si aplica).
      </p>
    </ng-container>
    <ng-container *ngIf="index === 3">
      <p class="text-document">
        El <span class="fw-600">certificado de matrimonio</span> emitido por el
        gobierno actualizado (si aplica).
      </p>
    </ng-container>
    <ng-container *ngIf="index === 4">
      <p class="text-document">
        El <span class="fw-600">certificado de unión civil</span> emitido por el
        gobierno actualizado (si aplica).
      </p>
    </ng-container>
  </div>
  <div class="contenedor">
    <img
      [src]="documentsImg[index - 1]?.img"
      [alt]="documentsImg[index - 1]?.alt"
    />
  </div>
  <div class="button-container">
    <div class="pagination-controls">
      <button
        type="button"
        class="icon-button"
        aria-label="Anterior"
        (click)="btnback()"
        [disabled]="index === 1"
      >
        <ion-icon name="chevron-back-outline"></ion-icon>
      </button>
      <span class="page-indicator">{{ index }} de 4</span>
      <button
        type="button"
        class="icon-button"
        aria-label="Siguiente"
        (click)="btnNext()"
        [disabled]="index === 4"
      >
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </button>
    </div>

    <button class="btn-basic btn-confirm" (click)="data?.closeButton()">Entendido</button>
  </div>
</div>
